<template>
  <div>
    <div class="mt-4 text-center">
      <v-dialog v-model="dialog" persistent scrollable>
        <v-card>
          <v-card-title>
            <v-row>
              <v-col lg="4" md="4" sm="4" class="col-12">
                <v-text-field
                  class="mt-4"
                  v-model="search"
                  append-icon=" fas fa-search"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-divider></v-divider>
              <v-col class="col-12">
                <v-data-table
                  v-model="platoSelect"
                  :headers="cabeceraPlato"
                  :items="platos"
                  item-key="idplato"
                  class="border"
                  :search="search"
                  :items-per-page="10"
                  :single-select="selected"
                  show-select
                  :loading="loading"
                  :mobile-breakpoint="0"
                  loading-text="Cargando... Espere un nomento"
                  no-results-text="No se encontraron datos"
                  no-data-text="No se encontraron datos"
                >
                  <template v-slot:item.desayuno="{ item }">
                    <v-icon color="red" small v-if="item.desayuno == 0">fas fa-times</v-icon>
                    <v-icon color="green" small v-else-if="item.desayuno == 1">fas fa-check</v-icon>
                  </template>
                  <template v-slot:item.almuerzo="{ item }">
                    <v-icon color="red" small v-if="item.almuerzo == 0">fas fa-times</v-icon>
                    <v-icon color="green" small v-else-if="item.almuerzo == 1">fas fa-check</v-icon>
                  </template>
                  <template v-slot:item.cena="{ item }">
                    <v-icon color="red" small v-if="item.cena == 0">fas fa-times</v-icon>
                    <v-icon color="green" small v-else-if="item.cena == 1">fas fa-check</v-icon>
                  </template>
                  <template v-slot:item.aceptataper="{ item }">
                    <v-icon color="red" small v-if="item.aceptataper == 0">fas fa-times</v-icon>
                    <v-icon color="green" small v-else-if="item.aceptataper == 1">fas fa-check</v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="cancelar()">Cancelar</v-btn>
            <v-btn color="primary" text @click="asignarPlatos()">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import ProgramacionMenuService from '../services/ProgramacionMenuService';

export default {
  name: 'PlatosListado',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    platosSeleccionados: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    loading: false,
    platoSelect: [],
    programacionMenuService: null,
    search: '',
    cabeceraPlato: [
      { text: 'idplato', value: 'idplato' },
      { text: 'descripcion', value: 'descripcion' },
      { text: 'descripcioncorta', value: 'descripcioncorta' },
      { text: 'desayuno', value: 'desayuno' },
      { text: 'almuerzo', value: 'almuerzo' },
      { text: 'cena', value: 'cena' },
      { text: 'aceptataper', value: 'aceptataper' }
    ],
    platos: []
  }),
  watch: {
    dialog(val) {
      if (val) {
        this.iniciaPlatos();
        this.platoSelect = [];
      }
    }
  },
  methods: {
    async iniciaPlatos() {
      this.loading = true;
      this.platos = [];
      const res = await this.programacionMenuService.get().execResource('platos', {
        idempresa: localStorage.getItem('emp'),
        activo: 1
      });
      if (res.length > 0) {
        this.platos = res;
      }
      this.loading = false;
    },
    cancelar() {
      this.$emit('cancelar');
    },
    asignarPlatos() {
      this.$emit('asignarPlatos', [...this.platoSelect]);
    }
  },
  async mounted() {
    this.programacionMenuService = this.$httpService(new ProgramacionMenuService(), this);
  }
};
</script>

<style lang="scss">
.sel-popup .v-input__control {
  margin-top: 12px;
}
</style>
